export class ErrorRing {
  private buf: string[] = [];
  constructor(private cap = 50) {}
  push(msg: string) { this.buf.push(msg.slice(0, 200)); if (this.buf.length > this.cap) this.buf.shift(); }
  list(): string[] { return [...this.buf]; }
}

export const errorRing = new ErrorRing();

let installed = false;
/** Idempotently capture runtime errors into the ring (call once at app start). */
export function installErrorCapture(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  window.addEventListener('error', (e) => errorRing.push(`error: ${e.message}`));
  window.addEventListener('unhandledrejection', (e) => errorRing.push(`unhandledrejection: ${String((e as PromiseRejectionEvent).reason)}`));
}
